import { useAtom, useSetAtom } from 'jotai'
import { useEffect, useReducer, useRef } from 'react'
import { navItemsAtom, roleOptionsAtom, selectedRoleAtom } from '@/atoms'
import type { GetCurrentUserResponse } from '@/types/directus/current-user'
import { SidenavActionType, selectSidenavItems, sidenavInitialState, sidenavReducer } from './sidenavReducer'

export function useSidenav(response: GetCurrentUserResponse | undefined, pathname: string) {
  const [state, dispatch] = useReducer(sidenavReducer, sidenavInitialState)
  const [selectedRole, setSelectedRole] = useAtom(selectedRoleAtom)
  const setRoleOptions = useSetAtom(roleOptionsAtom)
  const setNavItems = useSetAtom(navItemsAtom)
  const selectedRoleId = selectedRole?.id ?? null
  const roleIdRef = useRef(selectedRoleId)
  roleIdRef.current = selectedRoleId

  useEffect(() => {
    if (response?.success && response.data) {
      dispatch({
        type: SidenavActionType.SYNC_USER_ME,
        payload: { user: response.data, selectedRoleId: roleIdRef.current }
      })
    } else {
      dispatch({ type: SidenavActionType.RESET })
    }
  }, [response])

  useEffect(() => {
    dispatch({ type: SidenavActionType.SELECT_ROLE, payload: selectedRoleId })
  }, [selectedRoleId])

  useEffect(() => {
    setRoleOptions(state.roleOptions)
    setSelectedRole(state.roleOptions.find(role => role.id === state.selectedRoleId) ?? null)
  }, [state.roleOptions, state.selectedRoleId, setRoleOptions, setSelectedRole])

  const items = selectSidenavItems(state, pathname)
  useEffect(() => {
    setNavItems(items)
  }, [items, setNavItems])
}
